import { classNames } from "primereact/utils"
import styles from "./styles.module.css"
import { OrderState } from "../../../api/types/constants"

export const OrderStateTag = ({ options, value }: Props) => {
  const state = options.find((option) => option.value === value)

  const cn = classNames({
    [styles.state]: true,
    [styles.inProgress]: value === 0,
    [styles.toSend]: value === 1,
    [styles.sent]: value >= 10 && value < 100,
    [styles.finished]: value === 100,
    [styles.storno]: value < 0,
  })

  return (
    <div className={cn}>
      {state?.label || ""}
    </div>
  )
}

export const isOrderEditable = (value: number): boolean => value >= 0 && value < 10

export const isOrderPrintable = (value: number): boolean => value >= 10 && value <= 12

interface Props {
  options: OrderState[];
  value: number;
}
